import { useAuthStore } from '@lib/store/authStore';
import type { AuthState } from '@shared/types/user';

/**
 * Hook to access authentication state and user profile
 * Returns user, loading state, and authentication status
 */
export function useAuth(): AuthState {
  const user = useAuthStore((state) => state.user);
  const isLoading = useAuthStore((state) => state.isLoading);

  return {
    user,
    isLoading,
    isAuthenticated: user !== null,
  };
}

